import { createClient } from '@supabase/supabase-js';
import { projectId, publicAnonKey } from './info';

// Lazy-loaded singleton - client only created when first accessed
let _client: ReturnType<typeof createClient> | null = null;

export function getSupabaseClient() {
  if (!_client) {
    _client = createClient(
      `https://${projectId}.supabase.co`,
      publicAnonKey,
      {
        auth: {
          persistSession: true,
          autoRefreshToken: true,
        }
      }
    );
  }
  return _client;
}

// For backwards compatibility, export as supabase
// But this will be created immediately on import - defeating lazy loading
// Better to use getSupabaseClient() directly
export const supabase = getSupabaseClient();
